enum COMMON_FIELDS {
	// custom ui
	IS_LOADING = "isLoading",
	ID = "id",
	ARR = "arr",
	YEAR = "year",
	PLACEHOLDER = "placeholder",
	ERROR = "error",
	IS_ACTIVE = "isActive",
	ON_CHANGE = "onChange",
	WIDTH_WINDOW = "widthWindow",
	VALUE = "value",
	UPDATED_AT = "updatedAt",
	TREND = "trend",
	NAME = "name",
	LABEL = "label",
	DISABLED = "disabled",
	IS_LOADING_PAGINATION = "isLoadingPagination",
	ON_CLICK = "onClick",
	FULL_WIDTH = "fullWidth",
	TITLE = "title",
	CONTENT = "content",
	ITEM = "item",
	NUM_COLUMNS = "numColumns",
	KEY = "key",
	DATA = "data",
	LIST = "list",
	SIZE = "size",
	COLOR = "color",
	STATUS = "status",
	COUNT = "count",
	TOTAL = "TOTAL",
	OPTIONS = "options",
	TYPE = "type",
	STYLE = "style",
	MAX_LENGTH = "maxLength",
	WARNING = "warning",
	CODE = "code",
	// custom bll
	NAVIGATION = "navigation",
	ROUTE = "route",
	ROUTES = "routes",
	PAGE_COUNT = "pageCount",
	CURRENT_PAGE = "currentPage",
	PATCH = "patch",
	ELEMENT = "element",
	CHILDREN = "children",
	ICON = "icon",
	DELAY = "delay",
	LINK = "link",
	DTO = "dto",
	SHARED = "shared",
	TOKEN = "TOKEN",
	IS_NEED_CHANGE = "isNeedChange",
	CUSTOM_STATUS = "customStatus",
	//custom FIELDS
	//ON_ANIMATION_FINISH - Эта штука используется для Lottie анимации
	ON_ANIMATION_FINISH = "onAnimationFinish",
	AUTH_PAGES = "authPages",
	SHARED_PAGES = "sharedPages",
	USER = "user",
	AVATAR = "avatar",
	OPEN = "open",
	ON_CLOSE = "onClose",
	DIVISION = "division",
	PARENT_NAMES = "parentNames",
	ITEMS = "items",
	IS_ERROR = "isError",
	IS_EMPTY = "isEmpty",
	ON_OPEN_MODAL = "onOpenModal",
	LEVEL = "level",
	FOUND_DIVISIONS_KEYS = "foundDivisionsKeys",
	SORT_BY = "sortBy",
	DESCRIPTION = "description",
	COUNT_OF_INDICATORS = "countOfIndicators",
	MENU = "menu",
	CONTROLS = "controls",
	VARIANT = "variant",
	CHARTDATA = "chartData",
	START_DATE = "startDate",
	FINISH_DATE = "finishDate",
	MIN_LIMIT = "minLimit",
	MAX_LIMIT = "maxLimit",
	DATE = "date",
	CHECKED = "checked",
	IS_PINNED = "isPinned",
	ON_PIN = "onPin",
	ON_UNPIN = "onUnPin",
	FILTERS = "filters",
	DETAIL = "detail",
}

export default COMMON_FIELDS;
